module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "x06_Neal_4.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Opener"
  }, [_c('p', {
    staticClass: "Chapter-Front-Ch-Num-17"
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("Four")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "Chapter-Front-Title-17"
  }, [_vm._v("Executive Perquisites")])]), _c('p', {
    staticClass: "Chapter-Body-First-15"
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("In 1966, the Beatles recorded “Strawberry Fields Forever,” with lyrics written by John Lennon although attributed to both Lennon and Paul McCartney.")]), _c('a', {
    attrs: {
      "id": "x4n1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-First-NoteCallout-9",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("1")])]), _vm._v(" In the fall of 1980, Lennon gave an interview that appeared in "), _c('span', {
    staticClass: "Chapter-Body-First-Italic"
  }, [_vm._v("Playboy ")]), _vm._v("magazine in January of 1981. Lennon and his wife Yoko Ono sat down with freelance writer David Sheff in their home at the Dakota on Central Park West in Manhattan. When during the interview Sheff asked Lennon about the meaning of “Strawberry Fields Forever,” Lennon responded with an explanation of the lines "), _c('span', {
    staticClass: "Chapter-Body-First-Italic"
  }, [_vm._v("Living is easy with eyes closed.")]), _vm._v(" "), _c('span', {
    staticClass: "Chapter-Body-First-Italic"
  }, [_vm._v("Misunderstanding all you see.")]), _vm._v(" Lennon said, “I was different from the others. I was different all my life. The second verse goes, ‘No one I think is in my tree.’ . . . Nobody seems to be as hip as me is what I was saying. Therefore, I must be crazy or a genius.” In sum, Lennon said reality was whatever he wanted it to be; that to him, surrealism was reality."), _c('a', {
    attrs: {
      "id": "x4n2"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-First-NoteCallout-9",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("2")])]), _vm._v(" Before the interview appeared in "), _c('span', {
    staticClass: "Chapter-Body-First-Italic"
  }, [_vm._v("Playboy,")]), _vm._v(" John Lennon was shot and killed outside the Dakota on December 8, 1980."), _c('a', {
    attrs: {
      "id": "x4n3"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-First-NoteCallout-9",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("3")])]), _vm._v(" With the shots fired by Mark David Chapman, the building across the street from Central Park where the rich and famous lived was transformed from the luxurious New York home John Lennon shared with his wife into the place where his life came to a tragic and premature end.")]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Body-TextBreak-16"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Body-TextBreak-NoPara-16"
  }, [_vm._v("For many people, it would have been easy to see the potential problems created by a publicly traded corporation’s purchase of a luxury apartment that would be used by its CEO, a purchase that was authorized using less than one-tenth of the CEO’s Board-granted $200 million spending authority, that required only the CEO’s approval, and was structured to title the property in the CEO’s name personally. Why did a company the size of Tyco lack internal controls and Board oversight that would have prevented the purchase? Or at least would have required the CEO to seek advice and approval? In this case, the only involvement of Directors was Josh Berman’s letter of reference. The potential problems should have been obvious. But "), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("in 2000, Tyco and Kozlowski were on top of the world and Kozlowski didn’t foresee any problems with the decisions he made about the $18 million duplex.")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }), _c('p', {
    staticClass: "Chapter-Body-17"
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("Charles Lindbergh, one of Kozlowski’s heroes, once said that “[l]ife is like a landscape. You live in the midst of it but can describe it only from the vantage point of distance.”")]), _c('a', {
    attrs: {
      "id": "x4n4"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-NoteCallout-18",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("4")])]), _vm._v(" More than a decade after he approved the purchase of the 950 Fifth Avenue residence, a self-reflective Kozlowski wondered why he didn’t anticipate the trouble and questioned how he failed to better protect Tyco shareholders and himself. Kozlowski said, “We didn’t need that apartment. I don’t know why at the time I thought it was necessary.”"), _c('a', {
    attrs: {
      "id": "x4n5"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-NoteCallout-18",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Body-17"
  }, [_c('span', {
    staticClass: "Chapter-Body-Italic-15"
  }, [_vm._v("Living is easy with eyes closed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Body-TextBreak-16"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Body-TextBreak-NoPara-16"
  }, [_vm._v("Dennis Kozlowski and Tyco were not alone in the world of extravagant executive perquisites—like having access to a luxury corporate apartment. In the late 1990s and early 2000s, Tyco’s purchase of the 950 Fifth Avenue apartment was not beyond the pale or even unusual for a company of its size.")]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Body-17"
  }, [_vm._v("During the ugly and very public 2002 divorce of Jack F. Welch, Jr., the former CEO and Chairman of the Board of General Electric (GE), court filings disclosed a long list of executive perquisites GE provided to Welch. Included among the profligacy was a company-owned $11 million luxury apartment at the Trump International Hotel and Towers on Central Park West. In addition to providing Welch an expense-free home in Manhattan, GE also provided fresh flowers for the apartment, regular shipments of wine, a kitchen staff, a housekeeper, and dry cleaning and laundry services. The company even paid for part of Welch’s tab at Jean Georges, a pricy restaurant in the building."), _c('a', {
    attrs: {
      "id": "x4n6"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-NoteCallout-18",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Body-17"
  }, [_c('span', [_vm._v("When Welch’s perks were made public by his soon-to-be ex-wife, neither he nor GE disputed the expenditures. GE gave undivided, vocal support to its CEO and insisted that the company complied fully with disclosure requirements. Jack Welch, in his own and the company’s defense, stated that his generous compensation and perquisites “worked to the benefit of all constituencies.” Of note is the vast difference in support Welch received from GE when he was attacked for receiving lavish company benefits compared to the absolute lack of support offered by Tyco to its CEO. Instead of acknowledging the generous compensation and perks, or justifying them by pointing to the company’s performance under Kozlowski’s leadership, or even admitting that the company had paid its executives too much, Tyco Directors cut Kozlowski loose. GE had Welch’s back. Tyco fed Kozlowski to the sharks.")])]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Body-17"
  }, [_vm._v("During the barrage of media coverage at the time of Welch’s divorce, experts and commentators weighed in on the extravagant executive benefits GE bestowed on Welch. For example, corporate governance expert Nell Minnow called Welch’s compensation too generous and stated that “[t]here is really no justification to pay for any living or traveling expenses at that level. . . .” Rakesh Khurana, then Assistant "), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("Professor at the Harvard Business School, explained during a 2002 "), _c('span', {
    staticClass: "Chapter-Body-Italic-15"
  }, [_vm._v("PBS NewsHour")]), _vm._v(" interview that “it’s an extension of the sort of super-star CEO mentality that had been created over the last 15–20 years in which a CEO was sort of thought to deserve everything he got because he created all this value for the corporation.”")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "Chapter-Body-17"
  }, [_vm._v("With a legitimate, purely capitalistic counter argument, Welch pointed out that “ . . . [i]t was an employment contract. I fulfilled my obligations. GE did fantastically. It increased market cap $250 billion over the time frame, and became number one market cap in the world, most admired global company for five years in a row.” Despite the logic of his argument, Welch took a beating in the press. Shortly after news of his company-supported lifestyle became public, the embattled CEO gave up many of his perks.")]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Body-17"
  }, [_vm._v("In stark contrast to the detractors, there were commentators who disagreed with the criticism of Welch and GE. Edwin A. Locke, then Professor Emeritus at the University of Maryland at College Park, said in Welch’s defense that he should have answered critics by saying “I earned the benefits through decades of hard and successful work. I am proud of what I earned, and I intend to keep it.”")])]), _c('p', {
    staticClass: "Chapter-Body-17"
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("Nearly a decade after former CEOs Kozlowski and Welch were harshly criticized for their executive perks, Kozlowski addressed the Welch controversy. In a letter written from his prison cell in upstate New York, Kozlowski said he knew Jack Welch. “He’s a great business leader who was very lucky to have G.E. Capital during the booming days. Jack got away with less disclosure because he was Jack.” Kozlowski added, “We modeled my compensation system and retention agreement after Jack’s. It did not work out very well for me.” Kozlowski compared their relative consequences and noted that “Jack said he was sorry he got piggy and all was forgiven. It must be good to be Jack Welch.”")]), _c('a', {
    attrs: {
      "id": "x4n7"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-NoteCallout-18",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Body-17"
  }, [_vm._v("Lavish executive perquisites did not end with Welch-era CEOs. Chief executives and other Named Executive Officers (NEOs) continue to receive perks and the goodies get bigger and better with time."), _c('a', {
    attrs: {
      "id": "x4n8"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-NoteCallout-18",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("8")])]), _vm._v(" Publicly traded corporations are required to disclose to the U.S. Securities and Exchange Commission (SEC) and to shareholders the compensation paid to CEOs, CFOs, and other NEOs. A publicly traded corporation is a business organization that issues securities to the public. The securities are typically bonds, debt the company owes to investors, or shares of stock that give investors ownership interests in the corporation. A publicly traded corporation’s stock is made available to the public through a stock exchange or in the over-the-counter market. Both GE and Tyco International were (and continue to be) publicly traded corporations—the stock of both trade on the New York Stock Exchange using ticker symbols GE and TYC respectively."), _c('a', {
    attrs: {
      "id": "x4n9"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-NoteCallout-18",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Body-17"
  }, [_vm._v("The obvious advantage of being publicly traded is access to capital in amounts that are almost infinite so long as the investing public is willing to take a risk on the business. Along with the advantages come vastly increased reporting requirements and the burden of complying with thousands of state and federal securities "), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("regulations. A large number of these regulations require corporations to disclose financial and other significant information to the public so that investors can make educated judgments about buying securities.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }), _c('p', {
    staticClass: "Chapter-Body-17"
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("Executive compensation is one of the many required disclosures and must be included in proxy statements corporations file annually with the SEC. In addition to salaries, bonuses, stock options, and performance-based payments, a corporation must disclose perquisites provided to its executives.")]), _c('a', {
    attrs: {
      "id": "x4n10"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-NoteCallout-18",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("10")])]), _vm._v(" Even though the SEC requires disclosure of executive perquisites, the agency does not specifically define “perquisite.” During its most recent update of the regulation, the SEC confirmed a continuing belief “that it is not appropriate . . . to define perquisites or personal benefits, given that different forms of these items continue to develop, and thus a definition would become outdated.”"), _c('a', {
    attrs: {
      "id": "x4n11"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-NoteCallout-18",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("11")])]), _vm._v(" The SEC offers only that “perquisites” should be interpreted broadly and that the following guidelines be used in the determination of what should be disclosed:")]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Body-Ext-first-8"
  }, [_vm._v("An item is not a perquisite or personal benefit if it is integrally and directly related to the performance of the executive’s duties.")]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Body-Ext-last-6"
  }, [_vm._v("An item is a perquisite or personal benefit if it confers a direct or indirect benefit that has a personal aspect, without regard to whether it may be provided for some business reason or for the convenience of the company, unless it is generally available on a non-discriminatory basis to all employees."), _c('a', {
    attrs: {
      "id": "x4n12"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-Ext-last-NoteCallout-6",
    staticStyle: {
      "font-size": "1.11em"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Body-17"
  }, [_vm._v("Among the examples provided by the SEC of items considered perquisites and therefore must be disclosed are club memberships not used solely for business purposes, personal financial or tax advice, housing and relocation expenses, personal travel using company vehicles, and security provided at a personal residence."), _c('a', {
    attrs: {
      "id": "x4n13"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-NoteCallout-18",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Body-17"
  }, [_vm._v("After being disclosed to the SEC and shareholders, executive perks are frequently examined by analysts, watchdog organizations, journalists, and others who trudge through proxy statements to ferret out “All Other Compensation,”"), _c('a', {
    attrs: {
      "id": "x4n14"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-NoteCallout-18",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("14")])]), _vm._v(" which is the category under which perks are disclosed."), _c('a', {
    attrs: {
      "id": "x4n15"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-NoteCallout-18",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("15")])]), _vm._v(" Although these watchdogs, through the media, occasionally criticize elaborate perks granted to executives,"), _c('a', {
    attrs: {
      "id": "x4n16"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-NoteCallout-18",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("16")])]), _vm._v(" the attention hasn’t shamed boards of directors into reducing the lavish benefits offered to C-level executives.")]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Body-17"
  }, [_vm._v("Perhaps corporations that provide generous perks to their executives are doing the right thing. Perquisites are arguably good investments and in shareholders’ best interests. The most common justification voiced in favor of offering executive perquisites is the same core reason employers offer any type of employee benefit; executive perquisites allow a board of directors to recruit and retain the best talent, to attract and keep a CEO capable of growing a company as successfully as Jack Welch grew GE or as effectively as Dennis Kozlowski grew Tyco."), _c('a', {
    attrs: {
      "id": "x4n17"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-NoteCallout-18",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("17")])]), _vm._v(" In addition to helping with recruitment and retention, perks like company cars, use of corporate jets, and "), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("administrative and personal assistants allow executives to use their valuable time more productively. Other perks, like an annual physical exam, the services of a physician, and security services are provided to protect the health and safety of executives, and benefits like financial planning and tax gross-ups ensure compliance by executives with state and federal regulatory requirements.")]), _c('a', {
    attrs: {
      "id": "x4n18"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-NoteCallout-18",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Body-17"
  }, [_vm._v("In response to the financial crisis of 2008, the U.S. Congress passed in 2010 the Dodd-Frank Wall Street Reform and Consumer Protection Act (Dodd-Frank or the Act). Under Dodd-Frank, publicly traded corporations became subject to more rigorous disclosure mandates, including a requirement that executive pay be directly compared to the performance of the company. Another Dodd-Frank provision requires disclosure of executive compensation in comparison to the median salary of all other employees in the company. The Act also created a “say-for-pay” requirement under which corporations must allow their shareholders to vote at least once every three years on executive compensation. Although the results of shareholder voting are technically non-binding, boards of directors at even the largest organizations recognize it is patently unwise to award executive pay packages that shareholders do not support."), _c('a', {
    attrs: {
      "id": "x4n19"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-NoteCallout-18",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Body-17"
  }, [_vm._v("Dodd-Frank was enacted to regulate the financial services sector, however the provisions related to executive compensation reach far beyond Wall Street. The desired effect of the enhanced disclosures required by Dodd-Frank is to provide additional information to shareholders and to promote shareholder engagement—to bolster basic corporate governance mechanisms. Even though sweeping legislation like Dodd-Frank creates expensive and burdensome compliance issues for publicly traded companies, perhaps the additional regulations will prevent another instance like Jack Welch and GE having to defend executive perquisites disclosed during a messy divorce and reduce the possibility of an executive like Dennis Kozlowski and a company like Tyco having to explain the CEO’s luxury apartment during criminal trials. Compliance is expensive, but it is not nearly as costly as scandal, litigation, indictments, and loss of investor confidence.")]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Body-TextBreak-16"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Body-TextBreak-NoPara-16"
  }, [_vm._v("Criticism of Kozlowski’s purchase of the units at 950 Fifth Avenue grew exponentially when the media found out that, in addition to the multi-million dollar apartment, Kozlowski authorized the services of an interior designer to redecorate it. In more damning testimony during Kozlowski’s second criminal trial, Kathy McRae testified that “Mr. Kozlowski had told me that there was going to be a cap of . . . six million dollars for renovations and furniture for the apartment, and I kept a running total of what invoices were paid and what was left for a balance; and I got the invoices in the Executive Treasury and asked they be paid from a Tyco account.”"), _c('a', {
    attrs: {
      "id": "x4n20"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-TextBreak-NoPara-NoteCallout-14",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Body-17"
  }, [_vm._v("Kozlowski hired Seldom Scene Interiors of Nantucket to decorate the apartment."), _c('a', {
    attrs: {
      "id": "x4n21"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-NoteCallout-18",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("21")])]), _vm._v(" The firm was owned by Wendy Valliere, a friend of Kozlowski’s second wife "), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("Karen. According to the testimony of several witnesses during Kozlowski’s trials, Kozlowski and his wife were very friendly with Valliere, and the witnesses noted that Kozlowski used Valliere’s firm for many decorating and renovation projects in several states over a number of years. When questioned about the expensive redecorating project during his second trial, Kozlowski insisted that renovations were necessary before he was able to use the apartment.")]), _c('a', {
    attrs: {
      "id": "x4n22"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-NoteCallout-18",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("22")])]), _vm._v(" About hiring Valliere, Kozlowski said, “I hired someone I knew—someone from Nantucket,” and he emphasized (about someone he once considered a friend), “I have not spoken to [Valliere] since.”"), _c('a', {
    attrs: {
      "id": "x4n23"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-NoteCallout-18",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Body-17"
  }, [_vm._v("Cognitive psychologists have studied how a seemingly intelligent person like Dennis Kozlowski could misjudge the potential problems of hiring his wife’s friend for a multi-million dollar project. Research has shown that risk-perception systems are affected by trust, and even intelligent people tend to minimize the assessed risk when dealing with those they trust. When the same people deal with individuals with whom no level of trust has been established, they tend to assess the risk as greater than it is in reality—they exaggerate the risk."), _c('a', {
    attrs: {
      "id": "x4n24"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-NoteCallout-18",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("24")])]), _vm._v(" If Dennis Kozlowski had insisted on a more arm’s-length relationship, if he had hired an unknown decorator, a decorator he didn’t trust, perhaps he would have been more diligent in overseeing the project. Kozlowski’s ability to accurately assess and manage the risks was clouded because he hired his wife’s friend, because he hired someone he trusted. His use of Valliere in the Fifth Avenue redecorating project was one of many relationships of trust that became problematic for Kozlowski.")]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Body-17"
  }, [_vm._v("In retrospect, Kozlowski admitted that he made mistakes with the renovation. He said, “There were purchases that I would never have made, one of which was that damn shower curtain. No one in their right mind would pay $6,000 for a shower curtain.” Kozlowski said he wanted a “corporate looking” apartment suitable for business meetings. “The apartment was off the beaten path. We were going to use it for meetings. We were going to buy companies there,” he insisted."), _c('a', {
    attrs: {
      "id": "x4n25"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-NoteCallout-18",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Body-17"
  }, [_vm._v("During his second trial, Kozlowski recounted the instructions he gave Valliere about the apartment. He said, “My instructions were to work with Tyco’s facilities manager, a fellow by the name of John [Taylor], to coordinate with him and to call me when the apartment was habitable, when I could move in and use the apartment when I was in New York.”"), _c('a', {
    attrs: {
      "id": "x4n26"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-NoteCallout-18",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("26")])]), _vm._v(" Neither Kozlowski nor his then wife Karen selected anything for the apartment during the renovation—not one piece of furniture, not one fixture. He left all of the decision-making to the decorator. In one of the hundreds of articles written in criticism of the adornment of the Tyco corporate apartment, a journalist coined as “Mogul style” the practice of providing CEOs with extravagant homes. In the same article, a New York interior designer who worked with high-end clients like Kozlowski said it was not unusual and in fact quite feasible for the rich to spend the kind of money that Tyco, at Kozlowski’s direction, spent on the 950 Fifth Avenue apartment."), _c('a', {
    attrs: {
      "id": "x4n27"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-NoteCallout-18",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Body-17"
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("Among the Mogul style design choices for the duplex were a $15,000 dog-shaped umbrella stand, a $6,300 sewing basket, a $17,000 traveling toilette box, a $2,200 gold-plated wastebasket, $2,900 worth of coat hangers, a $1,650 appointment book, a set of sheets that cost $5,900, a $445 pincushion, and the $6,000 shower curtain.")]), _c('a', {
    attrs: {
      "id": "x4n28"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-NoteCallout-18",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("28")])]), _vm._v(" In the end, Tyco spent $11 million to redecorate the Fifth Avenue apartment—a budget-blowing expenditure approved by CEO Dennis Kozlowski."), _c('a', {
    attrs: {
      "id": "x4n29"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-NoteCallout-18",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("29")])]), _vm._v(" He expressed strong feelings about the lavishly decorated duplex. “I could live comfortably on a 30-foot sailboat. That’s how I’d like to live,” Kozlowski explained. “I couldn’t give a shit about the redecorating. I had no interest. I was busy running the company.”"), _c('a', {
    attrs: {
      "id": "x4n30"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-NoteCallout-18",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Body-17"
  }, [_vm._v("He should have given a shit about the redecorating. His failure to oversee the project proved a costly mistake, ultimately far more detrimental to him than the $11,173,927 price tag."), _c('a', {
    attrs: {
      "id": "x4n31"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-NoteCallout-18",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("31")])]), _vm._v(" The extravagant purchases for the Fifth Avenue apartment became public knowledge when unnamed sources revealed the list to "), _c('span', {
    staticClass: "Chapter-Body-Italic-15"
  }, [_vm._v("Wall Street Journal")]), _vm._v(" reporters in August of 2002. In the resultant article, reporters Mark Maremont and Laurie P. Cohen cited as their sources “people investigating the company” and revealed the list of expensive furnishings purchased for the corporate apartment. In the same article, interior designer Wendy Valliere described the furnishings as “so mid-range compared to what a lot of people do.”"), _c('a', {
    attrs: {
      "id": "x4n32"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-NoteCallout-18",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Body-17"
  }, [_vm._v("More than a month later, on September 10, 2002, Tyco filed a Form 8-K with the SEC in which the company chose to officially disclose the list of furnishings for the Fifth Avenue apartment."), _c('a', {
    attrs: {
      "id": "x4n33"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-NoteCallout-18",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("33")])]), _vm._v(" Publicly traded corporations like Tyco use a Form 8-K to report to the SEC unscheduled or unexpected material events. Tyco’s September 2002 8-K disclosed to the SEC, to shareholders, and to the public details of a corporate scandal unfolding inside the company—events that resulted in indictments that month of the company’s former CEO Dennis Kozlowski, its then CFO Mark Swartz, and former Chief Corporate Counsel Mark Belnick. Tyco disclosed that “[t]he improper and unlawful conduct of Tyco’s former CEO, CFO and Chief Corporate Counsel in enriching themselves at the expense of the Company with no colorable benefit to the Company has damaged Tyco. The amount of money improperly diverted by Tyco’s former executives from the Company to themselves is very small in comparison with Tyco’s total revenues and profits, but it is very large by any other relevant comparison; and the extent of the former executives’ misconduct has harmed Tyco’s reputation and credibility with investors, lenders, and others.”"), _c('a', {
    attrs: {
      "id": "x4n34"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n34",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-NoteCallout-18",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("34")])])]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Body-17"
  }, [_vm._v("The Board opted to disclose the list of purchases, noting that “in the interest of restoring confidence in the Company, the extent of the Company’s disclosures in this filing will go beyond what the law requires, or what might ordinarily be disclosed in other circumstances.”"), _c('a', {
    attrs: {
      "id": "x4n35"
    }
  }), _c('span', {
    attrs: {
      "href": "#/25_Neal_notes#x4n35",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Chapter-Body-NoteCallout-18",
    staticStyle: {
      "font-size": "1em"
    }
  }, [_vm._v("35")])]), _vm._v(" The disclosures of what were non-material amounts—a $6,000 expenditure by a company with nearly $40 billion in annual revenue, an expenditure that was .00000015 percent of the company’s income—was "), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("questionable. Perhaps the extraordinary transparency, the disclosure of information not required of Tyco, caused an avoidable negative reaction. It may have caused a damaging and intentionally induced overreaction in the market, which is one of the reasons the SEC does not require disclosure of such items. Would Tyco shareholders have been better served if the company didn’t disclose those sensational but non-material expenditures in the September 2002 8-K? Or was absolute transparency the right decision, especially after the information had been leaked to the media a month earlier? Were Tyco shareholders entitled to know the types of expenses CEO Dennis Kozlowski approved with the authority he was given by the Tyco Board of Directors? Why didn’t the 8-K disclose the $200 million spending authority the Board had granted the CEO? Weren’t Tyco shareholders entitled to that information as well? Surely the Board, “in the interest of restoring confidence in the Company,” would not have "), _c('span', {
    staticClass: "Chapter-Body-Italic-15"
  }, [_vm._v("selectively")]), _vm._v(" disclosed information in the 8-K.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "Chapter-Body-17"
  }, [_vm._v("Although the outrageous details disclosed in the 8-K temporarily affected the value of Tyco stock, were embraced by the media, and used by Tyco, the Board of Directors, and the Manhattan District Attorney to initiate assaults on Kozlowski, Swartz, and Belnick, the opulent furnishings in the Fifth Avenue apartment were of little concern in comparison to the other problems that snowballed out of control after the 8-K was filed with the SEC.")]), _vm._v(" "), _c('p', {
    staticClass: "Bibliography-23"
  })])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  })]), _c('a', {
    attrs: {
      "id": "page28"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-749a416a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_Neal_4.vue
// module id = 93
// module chunks = 0